// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file.session {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  max-width: 100%;
  margin-top: 10px;
}

.file.session .content {
  flex: 1;
  overflow: auto;
}

.file.session .content pre {
  overflow: initial;
}

.file.session.nfo .file-content pre {
  font-family: 'Courier New', 'DejaVu Sans Mono', monospace;
  font-size: 11px;
  line-height: 12px;
  padding: 3px;
  margin: 0px;
}

.file.session img,
.file.session video {
  max-width: 100%;
  max-height: 99%;
}

/* The fullscreen mode conflicts with layout styles in Webkit-based browsers */
:-webkit-full-screen-ancestor:not(iframe) {
  max-width: inherit !important;
  overflow-x: initial;
}

:-webkit-full-screen-ancestor:not(iframe) #side-menu {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Sidebar/routes/Files/style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yDAAyD;EACzD,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".file.session {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n  max-width: 100%;\n  margin-top: 10px;\n}\n\n.file.session .content {\n  flex: 1;\n  overflow: auto;\n}\n\n.file.session .content pre {\n  overflow: initial;\n}\n\n.file.session.nfo .file-content pre {\n  font-family: 'Courier New', 'DejaVu Sans Mono', monospace;\n  font-size: 11px;\n  line-height: 12px;\n  padding: 3px;\n  margin: 0px;\n}\n\n.file.session img,\n.file.session video {\n  max-width: 100%;\n  max-height: 99%;\n}\n\n/* The fullscreen mode conflicts with layout styles in Webkit-based browsers */\n:-webkit-full-screen-ancestor:not(iframe) {\n  max-width: inherit !important;\n  overflow-x: initial;\n}\n\n:-webkit-full-screen-ancestor:not(iframe) #side-menu {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
